import { Avatar } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { useI18n } from '@/contexts/I18nContext';

interface ExchangeLogoProps {
  src?: string | null;
  name?: string | null;
  id?: string | null;
  size?: number;
}

export default function ExchangeLogo({ src, name, id, size = 28 }: ExchangeLogoProps) {
  const { t } = useI18n();
  const label = name || id || t('common.exchangeFallback');
  const fallback = (name || id || '?').slice(0, 2).toUpperCase();

  return (
    <Avatar
      src={src || undefined}
      alt={t('common.logoAlt', { name: label })}
      imgProps={{ referrerPolicy: 'no-referrer' }}
      sx={{
        width: size,
        height: size,
        flexShrink: 0,
        border: '1px solid rgba(226, 255, 238, 0.16)',
        bgcolor: src ? 'rgba(244, 255, 249, 0.94)' : alpha('#F4FFF9', 0.08),
        color: src ? '#06120D' : 'text.secondary',
        fontSize: size <= 24 ? '0.58rem' : '0.68rem',
        fontWeight: 800,
        '& img': {
          objectFit: 'contain',
          padding: size <= 24 ? '4px' : '5px',
        },
      }}
    >
      {fallback}
    </Avatar>
  );
}
